module.exports = __webpack_public_path__ + "img/coworkers-reviewing-task.1559e818.png";